import uniqBy from 'lodash/uniqBy';

export const sessionStorageKeys = {
  manuallyAccepted: 'manuallyAccepted',
  tenants: 'tenants',
};

export const setSessionStorageData = (key, data) =>
  window.sessionStorage.setItem(key, data);

export const getSessionStorageData = (key) => {
  try {
    const d = window.sessionStorage.getItem(key);

    return JSON.parse(d);
  } catch (e) {
    return undefined;
  }
};

export const deleteSessionStorageData = (key) =>
  window.sessionStorage.removeItem(key);

export const getManuallyAccepted = () =>
  getSessionStorageData(sessionStorageKeys.manuallyAccepted) || [];

export const setManuallyAccepted = (data = []) =>
  setSessionStorageData(
    sessionStorageKeys.manuallyAccepted,
    JSON.stringify(data)
  );

export const removeManuallyAccepted = () =>
  deleteSessionStorageData(sessionStorageKeys.manuallyAccepted);

export const getTenants = () =>
  getSessionStorageData(sessionStorageKeys.tenants) || [];

export const setTenants = (data = []) =>
  setSessionStorageData(sessionStorageKeys.tenants, JSON.stringify(data));

export const removeTenants = () =>
  deleteSessionStorageData(sessionStorageKeys.tenants);

export const cacheTenants = (tenants = []) => {
  const oldTenants = getTenants();
  const newTenants = uniqBy([oldTenants, tenants].flat(), 'id');
  setTenants(newTenants);
};
